export enum goalTypeEnum {
  Potential = 1,
  Continuity = 2,
  BusinessPlan = 3,
  Manual = 4
}
